module.exports = __webpack_public_path__ + "78031b95f24f0e19aa536090c9013686.svg";